var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edit-dialog',{attrs:{"value":_vm.value,"id":_vm.id,"model":_vm.model,"api":_vm.api},on:{"input":function($event){return _vm.$emit('input')}}})}
var staticRenderFns = []

export { render, staticRenderFns }